<template>
  <div class="stage-header" v-if="!isLoading">
    <div class="header-wrapper">
      <div class="page-title">{{ getPageTitle(this.$route.params.slug) }}</div>
      <div>
        <b-button class="reload-btn" variant="white" v-on:click="reload()" v-if="!isReloadProgress" :disabled='disableReload'>
          <reload-icon class="icon-default reload"></reload-icon>
          <span>Reload Data</span>
        </b-button>
        <b-button class="reload-btn" variant="white" v-else @click="terminateReloadData">
          <reload-icon class="icon-default reload" v-bind:class="{inprogress:isReloadProgress}"></reload-icon>
          <span v-if="currentReloadProgress">{{currentReloadProgress.loaded}} / {{currentReloadProgress.total}} sites
            <close-icon class="icon-default closedark"></close-icon>
          </span>
        </b-button>
        <label class="ago-time">
          <span v-if="isReloadProgress" class="loading"> Loading</span>
          <span v-else>
            {{lastReloadTime}}
          </span>
        </label>
      </div>
    </div>
    <b-row class="middle-notification-container m-0" v-if="clientPluginUpdates.siteIDs">
      <b-col class="notification-content warning">
        <warning-icon class="icon-default warning"></warning-icon>
        <span class="text">An update to the IWP Client Plugin is available.
        </span>
        <span class="link-action" @click="showClientPluginUpdateModal"> Update on {{clientPluginUpdates.siteIDs.length}} {{ 'site' | pluralize(clientPluginUpdates.siteIDs.length)}} now.</span>
        <client-plugin-update ref="clientpluginupdate" :update="clientPluginUpdates"></client-plugin-update>
      </b-col>
    </b-row>
    <b-row class="middle-notification-container m-0" v-if="isHavingWPVulns() && getVulnerabilityUpdates">
      <b-col class="notification-content error">
        <error-icon class="icon-default error"></error-icon>
        <span class="text">There are {{getVulnerabilityUpdates}}<span class="text" v-if="getVulnerabilityHiddenUpdates">({{getVulnerabilityHiddenUpdates}} hidden)</span> vulnerability updates. 
        </span>
        <span class="link-action" @click="showVulnsUpdate">Show only vulnerability updates</span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ReloadIcon from '../assets/reload.svg';
import WarningIcon from '../assets/warning.svg';
import CloseIcon from '../assets/close.svg';
import ErrorIcon from '../assets/error.svg';

import routes from '../router/routes';
import Utils from '../mixins/utils';

import clientPluginUpdate from './modals/ClientPluginUpdate';
import {EventBus} from '../event/event-bus.js';

export default {
  name: 'iwpnavbar',
  components: {
    ReloadIcon,
    WarningIcon,
    CloseIcon,
    clientPluginUpdate,
    ErrorIcon
  },
  props: ['isLoading'],
  data() {
    return {
      routes: [
       
      ],
      reloadSpinner: false, 
      disableReload: false
    };
  },
  watch: {
    isLoading(newVal, oldVal) {
      if (newVal === false) {
        let settings = this.$store.getters.getSettings;
        
        if (
          settings &&
          settings.appSettings &&
          settings.appSettings.enableReloadDataPageLoad === '1'
        ) {
          this.reload();
        }
      }
    },
  },
  computed: {
    siteUpdates() {
      return this.$store.getters.getSitesUpdates;
    },
    lastReloadTime() {
      return this.$store.getters.getLastReloadTime;
    },
    clientPluginUpdates() {
      return this.$store.getters.getClientPluginUpdateSites;
    },
    isReloadProgress() {
      let reloadProgress = this.$store.getters.getStateVariable(
        'currentReloadProgress'
      );
      if (_.isEmpty(reloadProgress)) return false;
      if (reloadProgress.loaded === reloadProgress.total) return false;
      return true;
    },
    currentReloadProgress() {
      if (this.isReloadProgress) {
        return this.$store.getters.getStateVariable('currentReloadProgress');
      }
      return false;
    },
    getMenus(){
        return this.$store.getters.getTopBarMenus;
    },
    getVulnerabilityUpdates(){
      var siteUpdates = this.$store.getters.getVulnerabilityUpdates('vulnerability');
      var filtered = _.filter(siteUpdates, { hiddenItem: false });
      return filtered.length;
    },
    getVulnerabilityHiddenUpdates(){
      var siteUpdates = this.$store.getters.getVulnerabilityUpdates('vulnerability');
      var filtered = _.filter(siteUpdates, { hiddenItem: true });
      return filtered.length;
    }
  },
  methods: {
    gotoRoute(route) {
      this.$router.push({ name: route.name });
    },
    gotoPage(route) {
      this.$router.push({ name: 'Manage', params: { slug: route.page } });
    },
    gotoPageWithQuery(route) {
      this.$router.push({ name: 'Manage', params: { slug: route.page },  query: { show: route.query } });
    },
    showClientPluginUpdateModal() {
      this.$refs.clientpluginupdate.$refs.clientpluginupdate.show();
    },
    getPageTitle() {
      let currentSlug = this.$route.params.slug;
      if (currentSlug === 'activityLog') {
        return 'Activity Log';
      }
      if (currentSlug === 'loginActivity') {
        return 'Login Log';
      }
      if (currentSlug === 'addons') {
        return 'Addons';
      }
      let routes = [];
      _.each(this.getMenus, route => {
        routes = routes.concat(route.children);
      });
      let item = _.find(routes, { page: currentSlug });
      if (item) {
        return item.name;
      }
    },
    reload() {
      let payload = {};
      this.disableReload = true;
      payload.action = 'getStats';
      payload.args = {
        siteIDs : this.$store.getters.selectedSiteIds
      };
      payload.requiredData = {
        getSitesV3: 1,
        getHistoryPanelHTMLV3: 1,
        getPluginsAndThemesV3: 1,
        getGroupsSitesV3: 1,
        getSitesUpdatesV3: 1,
        getSitesBackupsV3: 1,
        getClientUpdateAvailableSiteIDs: 1,
        getAdditionalStatsV3:1
      };
      this.$store
        .dispatch('sendAction', payload)
        .then(response => {
          this.disableReload = false;
          let actionID = response.actionResult.actionID;
          this.$store.commit('SET_STATE_VARIABLE', {
            variable: 'currentReloadActionID',
            value: response.actionResult.actionID
          });
          let getWaitData = response.data.getWaitData;
          this.$store.commit('SET_STATE_VARIABLE', {
            variable: 'currentReloadProgress',
            value: {
              total: getWaitData[actionID].total,
              loaded: getWaitData[actionID].loaded
            }
          });
        })
        .catch(err => {
          
        });
    },
    terminateReloadData() {
      let payload = {
        requiredData: {
          terminatePendingProcess: {
            actionID: this.$store.getters.getStateVariable(
              'currentReloadActionID'
            )
          }
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        
      });
    },
    isHavingWPVulns() {
      let installedAddons = this.$store.getters.getInstalledAddons;
      return _.indexOf(installedAddons,'WPVulns') > -1;
    },
    showVulnsUpdate(){
      this.gotoPageWithQuery({page:'updates', query:'vulnsupdate'});
      EventBus.$emit("showvulnsupdate", true);
    }
  }
};
</script>

<style>
</style>
